import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-chart-download-button',
  templateUrl: './table-chart-download-button.component.html',
  styleUrl: './table-chart-download-button.component.scss',
  standalone: false
})
export class TableChartDownloadButtonComponent {
  @Input() tooltipTextKey =
    'm2.sprint5.cockpit.card.table-download-button.tooltip';
  @Output() readonly buttonClick = new EventEmitter<void>();

  onClick() {
    this.buttonClick.emit();
  }
}
